<div>
    <h2>{{ 'Testa Barcode' | translate }}</h2>
    <div class="row">
        <div class="col-auto">
            <mat-form-field class="fullwidth">
                <label>SKU</label>
                <input matInput [(ngModel)]="sku" (keyup)="inputChanged()">
            </mat-form-field>
        </div>
        <div class="col-auto">
            <mat-form-field class="fullwidth">
                <label>{{ 'Barcode' | translate }}</label>
                <input matInput [(ngModel)]="barcode" (keyup)="inputChanged()">
            </mat-form-field>
        </div>
        <div class="col-auto">
            <br />
            <button mat-raised-button color="primary" (click)="testBarcode()">{{ 'Testa' | translate }}</button>
        </div>
    </div>
    <div *ngIf="result">
        <br />
        <h3>{{ 'Resultat:' | translate }}</h3>
        <div class="result">
            {{result}}
        </div>
    </div>

</div>
